import React from 'react';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
    label?: string;
    containerClassName?: string;
    variant?: 'bordered' | 'ghost';
    inputSize?: 'xs' | 'sm' | 'md' | 'lg';
    color?: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error';
}

export function Input({
    label,
    className = "",
    containerClassName = "",
    variant = 'bordered',
    inputSize,
    color,
    ...props
}: InputProps) {
    const baseClass = "input w-full rounded-lg";

    // Variant styles (inputs are bordered by default in daisyUI 5)
    let variantClass = "";
    if (variant === "bordered") variantClass = "border-base-content/20";
    else if (variant === "ghost") variantClass = "input-ghost";

    // Size styles
    let sizeClass = "";
    if (inputSize === "xs") sizeClass = "input-xs";
    else if (inputSize === "sm") sizeClass = "input-sm";
    else if (inputSize === "lg") sizeClass = "input-lg";

    // Color styles
    let colorClass = "";
    if (color === "primary") colorClass = "input-primary";
    else if (color === "secondary") colorClass = "input-secondary";
    else if (color === "accent") colorClass = "input-accent";
    else if (color === "info") colorClass = "input-info";
    else if (color === "success") colorClass = "input-success";
    else if (color === "warning") colorClass = "input-warning";
    else if (color === "error") colorClass = "input-error";

    const classes = [
        baseClass,
        variantClass,
        sizeClass,
        colorClass,
        className
    ].filter(Boolean).join(" ");

    return (
        <div className={`flex flex-col gap-1 ${containerClassName}`}>
            {label && <label className="label">{label}</label>}
            <input
                className={classes}
                {...props}
            />
        </div>
    );
}
